import APICaller from '../library/APICaller'

// Controller 이름
const BillsServices = {
  // [HttpMethod][APIName] (path, queryString | data ) {}

  /**
   * 청구내역 List
   * @param  {String} params.companyCode 회사코드
   * @param  {String} params.currentMonth 청구월
   * @param  {String} params.empNo 영업사원 번호
   * @param  {Number} params.pageNo 검색할 페이지 번호
   * @param  {Number} params.size 페이지당 출력 갯수
   * @param  {Number} params.searchCategory 검색 종류
   * @param  {Number} params.searchText 검색어
   * @return {Promise}
   */
  getBills ({ companyCode, empNo, pageNo, size, searchText, orderCol, desc,jobTitleCode,empAuthDept, category, startMonth, endMonth}) {
    return APICaller.get('/api/v1/bills', { companyCode, empNo, pageNo, size, searchText, orderCol, desc ,jobTitleCode,empAuthDept, category, startMonth, endMonth })
  },

  /**
   * 고객사별 청구 LIST
   * @param  {String} params.companyCode 회사코드
   * @param  {String} params.currentMonth 청구월
   * @param  {String} params.customerCode 고객번호
   * @param  {String} params.deptCode 부서코드
   * @param  {Number} params.pageNo 검색할 페이지 번호
   * @param  {Number} params.size 페이지당 출력 갯수
   * @return {Promise}
   */
  getInvoices ({ companyCode, currentMonth, customerCode, deptCode, pageNo, size, category }) {
    return APICaller.get('/api/v1/invoices', { companyCode, currentMonth, customerCode, deptCode, pageNo, size, category })
  },
  /**
   * 청구내역(이용료) 상세
   * @param  {String} invoiceNoInvoice 번호
   * @param  {String} params.companyCode 회사코드
   * @return {Promise}
   */
  getInvoicesWithInvoiceNo (invoiceNo) {
    return APICaller.get(`/api/v1/invoices/${invoiceNo}`)
  },
  /**
   * @param  {String} params.companyCode 회사코드
   * @param  {String} params.customerCode 고객번호
   * @param  {String} params.deptCode 부서코드
   * @param  {String} params.endMonth 청구 종료월
   * @param  {String} params.startMonth 청구 시작월
   * @return {Promise}
   */
  getInvoicesGetChartData ({ companyCode, customerCode, deptCode, endMonth, startMonth }) {
    return APICaller.get('/api/v1/invoices/get-chart-data', { companyCode, customerCode, deptCode, endMonth, startMonth })
  },
  /**
   * @param  {String} params.companyCode 회사코드
   * @param  {String} params.customerCode 고객번호
   * @param  {String} params.deptCode 부서코드
   * @return {Promise}
   */
  getCustomerBillUser ({ customerDeptCode, customerCode }) {
    return APICaller.get(`/api/v1/bills/billUser`, { customerDeptCode, customerCode })
  },
  getDateList () {
    return APICaller.get(`/api/v1/bills/date`)
  },

  resendEmail(invoiceNo) {
    return APICaller.get(`/api/v1/bills/reSendBill/${invoiceNo}`)
  },
  getJspUrl () {
    return APICaller.get(`/api/v1/api-url`)
  },

}

export default BillsServices



// WEBPACK FOOTER //
// ./src/services/BillsServices.js